import ErrorLogSliceView from 'components/admin/error-log/error-log-slice-view';
import { formatClockTime } from 'utils/error-log/format';
import { parseReduxSnapshot } from 'utils/error-log/parse-error-log-blobs';

type ErrorLogStateViewProps = {
  snapshot: unknown;
};

export default function ErrorLogStateView({
  snapshot
}: ErrorLogStateViewProps) {
  const parsed = parseReduxSnapshot(snapshot);
  if (!parsed) {
    return (
      <div className='text-sm text-gray-400'>No Redux snapshot recorded.</div>
    );
  }

  const sliceEntries = Object.entries(parsed.slices);
  const { droppedSlices } = parsed.meta;

  return (
    <div className='flex flex-col gap-3'>
      <div className='text-xs text-gray-500'>
        Captured at {formatClockTime(parsed.meta.capturedAt)}
      </div>
      {droppedSlices.length > 0 && (
        <div className='rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800'>
          The snapshot exceeded the size limit, so these slices were not
          captured: {droppedSlices.join(', ')}. Reproducing will keep the
          current values for them.
        </div>
      )}
      {sliceEntries.length === 0 && (
        <div className='text-sm text-gray-400'>The snapshot is empty.</div>
      )}
      {sliceEntries.map(([name, value]) => (
        <ErrorLogSliceView key={name} name={name} value={value} />
      ))}
    </div>
  );
}
